export enum zIndexGeneral {
  ModalOverlay = 10000,
  PopperTooltip = 10001,
  OverlayLayer = 10,
}
